import { getLocalizedString } from '@grandvisionhq/utils';

const getProductTitle = (orderLineItem, intl)=>{
    return getLocalizedString(orderLineItem.product.name, intl.locale);
};

export { getProductTitle };
//# sourceMappingURL=get-product-title.js.map
